import { getActiveFilter } from '../../../features/data-types'
import { O } from '../../../features/ui'
import { ValueFilter } from '../../../services/dynamo'
import { TableName } from '../../../tables'
import { useLoaders } from '../../common'
import { useSystemStateHooks } from '../../system'
import { Expense } from '../state/types'

export const useExpenseLoaders = () => {
    const systemHooks = useSystemStateHooks()

    const loaders = useLoaders()

    return (companyId = systemHooks.companyId) => {
        const loadAllExpenses = async (active = false) => {
            const { loadMultiple } = loaders(companyId)
            const options = active ? getActiveFilter() : undefined
            const response = await loadMultiple(TableName.EXPENSES, options)
            return response.dataTypes as Expense[]
        }

        const loadExpense = (
            id: string,
            dbRequest = false
        ) => {
            const { load } = loaders(companyId)
            return load(TableName.EXPENSES, id, dbRequest) as Promise<O<Expense>>
        }

        const loadExpenses = async (ids: string[]) => {
            const { loadByIds } = loaders(companyId)
            return loadByIds(TableName.EXPENSES, ids) as Promise<Expense[]>
        }

        const loadBranchExpenses = async (
            branchId: string,
            active = false
        ) => {
            const { loadMultiple } = loaders(companyId)
            let valueFilters: ValueFilter[] = [
                { prop: 'branchId', value: branchId }
            ]
            if (active) {
                valueFilters = valueFilters.concat(getActiveFilter().valueFilters!)
            }
            const options = { valueFilters }
            const response = await loadMultiple(TableName.EXPENSES, options)
            return response.dataTypes as Expense[]
        }

        const countExpenses = (propName: string, propValue: string) => {
            const options = {
                valueFilters: [{
                    value: propValue,
                    prop: propName
                }],
                limit: 1
            }
            const { count2 } = loaders(companyId)
            return count2(TableName.EXPENSES, options)
        }
        
        return {
            loadAllExpenses,
            loadExpense,
            loadExpenses,
            loadBranchExpenses,
            countExpenses
        }
    }
}
